<template>
  <div class="is-flex is-justify-content-center">
    <div class="browser-scaffold">
      <div class="top-bar">
        <div class="action-buttons">
          <span class="action-btn" style="background-color: red"></span>
          <span class="action-btn" style="background-color: orange"></span>
          <span class="action-btn" style="background-color: green"></span>
        </div>

        <div class="address-bar">
          <input class="browser-default address-bar-input" type="text" :value="address" readonly>
        </div>

        <div class="more">
          <slot name="more"></slot>
        </div>
      </div>
      <div class="body">
        <slot name="body"></slot>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    address: {
      type: String
    }
  }
}
</script>

<style lang="scss" scoped>
.browser-scaffold {
  --width: 800px;
  --height: 450px;
  --shadow-color: #ccc;

  --top-bar-bg: #eee;
  --top-bar-height: 44px;

  --action-buttons-min-width: 100px;
  --more-min-width: 100px;

  --address-bar-bg: #fff;

  --body-bg: #eaeaea;

  width: var(--width);
  height: var(--height);
  overflow: hidden;
  display: flex;
  flex-direction: column;
  box-shadow: 0 0px 4px var(--shadow-color);

  .top-bar {
    background-color: var(--top-bar-bg);
    height: var(--top-bar-height);
    display: flex;
    align-items: center;

    .action-buttons {
      min-width: var(--action-buttons-min-width);

      .action-btn {
        width: 10px;
        height: 10px;
        display: inline-block;
        margin-left: 10px;
        border-radius: 50%;
      }
    }

    .address-bar {
      background-color: var(--address-bar-bg);
      padding: 4px 10px;
      border-radius: 4px;
      flex: 1;
      line-height: 1.15;

      input {
        width: 100%;
        border: none;
        padding: 0;
        outline: none;
        font-size: 1em;
      }
    }

    .more {
      min-width: var(--more-min-width);
      padding-right: 15px;
    }
  }

  .body {
    width: 100%;
    height: 100%;
    background-color: var(--body-bg);
  }
}
</style>
